import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
  Fragment,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
  checkArray,
  checkNull,
  changeDateFormat,
} from "../../../../../../helpers";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  changeSettingValue,
  getMasterSetting,
  refreshSalesMasterSetting,
  saveSalesMasterSetting,
  updateSalesMasterSetting,
  updateSalesMasterSettingStatus,
} from "../../../../../../Redux/actions";
import ModelContainer from "../../../../../Components/ModelContainer";
import ErrorContainer from "../../../../../Components/ErrorContainer";

const salesMasterSettingSchema = yup.object({
  id: yup.string().nullable(),
  sales_type_id: yup.string().required(),
  accounts: yup.array().nullable(),
});
const editSalesMasterSettingSchema = yup.object({
  master_id: yup.string().required(),
  sales_type_id: yup.string().required(),
  merchant_id: yup.string().required(),
  cluster_id: yup.string().required(),
  store_merchant_id: yup.string().required(),
});

const Sales = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const {
    master_setting_details,
    salesMasterSettingModal,
    is_salesMasterSetting_loading,
    editSalesMasterSettingModal,
    is_editSalesMasterSetting_loading,
  } = useSelector((state) => state.settingReducer);

  useEffect(() => {
    dispatch(getMasterSetting());

    return () => {
      dispatch(changeSettingValue("master_setting_details", null));
    };
  }, []);

  /* SalesMasterSettings */
  const initialsalesMasterSettingForm = {
    id: "",
    sales_type_id: "",
    accounts: [],
  };
  const {
    register: salesMasterSettingReg,
    formState: { errors: salesMasterSettingErrors },
    handleSubmit: salesMasterSettingSubmit,
    setValue: salesMasterSettingSetValue,
    reset: salesMasterSettingReset,
  } = useForm({
    resolver: yupResolver(salesMasterSettingSchema),
    defaultValues: initialsalesMasterSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [salesMasterSettingInputForm, setSalesMasterSettingInputForm] =
    useState(initialsalesMasterSettingForm);

  const [accounts, setAccounts] = useState([]);

  const changeSalesMasterSettingInputHandler = (input, val) => {
    salesMasterSettingSetValue(input, val);
    setSalesMasterSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const initialSalesMasterSettingModalState = (
    initailVal = initialsalesMasterSettingForm
  ) => {
    setSalesMasterSettingInputForm(initailVal);
    salesMasterSettingReset(initailVal);
  };
  const closeSalesMasterSettingModal = useCallback(
    (value) => {
      dispatch(changeSettingValue("salesMasterSettingModal", value));
      initialSalesMasterSettingModalState();
    },
    [salesMasterSettingModal]
  );
  const submitSalesMasterSettingForm = (data) => {
    data.accounts = accounts;
    data.setting_type = 1;
    console.log("submitSalesMasterSettingForm", data);
    dispatch(saveSalesMasterSetting(data));
  };
  const submitPmMasterUpdateSettingForm = (data) => {
    data.accounts = accounts;
    data.setting_type = 2;
    console.log("submitPmMasterUpdateSettingForm", data);
    dispatch(saveSalesMasterSetting(data));
  };
  const deleteSalesMasterSettingHandler = (id) => {
    // dispatch(deleteSalesMasterSetting({ id }));
  };

  /* Edit pm Master Setting */

  const initialeditSalesMasterSettingForm = {
    master_id: "",
    sales_type_id: "",
    merchant_id: "",
    cluster_id: "",
    store_merchant_id: "",
  };
  const {
    register: editSalesMasterSettingReg,
    formState: { errors: editSalesMasterSettingErrors },
    handleSubmit: editSalesMasterSettingSubmit,
    setValue: editSalesMasterSettingSetValue,
    reset: editSalesMasterSettingReset,
  } = useForm({
    resolver: yupResolver(editSalesMasterSettingSchema),
    defaultValues: initialeditSalesMasterSettingForm,
    mode: "all",
    reValidateMode: "onChange",
  });
  const [selectedSaleSetting, setSelectedSaleSetting] = useState(null);
  const [editSalesMasterSettingInputForm, setEditSalesMasterSettingInputForm] =
    useState(initialeditSalesMasterSettingForm);

  const changeEditSalesMasterSettingInputHandler = (input, val) => {
    editSalesMasterSettingSetValue(input, val);
    setEditSalesMasterSettingInputForm((prevState) => ({
      ...prevState,
      [input]: val,
    }));
  };
  const initialEditSalesMasterSettingModalState = (
    initailVal = initialeditSalesMasterSettingForm
  ) => {
    setEditSalesMasterSettingInputForm(initailVal);
    editSalesMasterSettingReset(initailVal);
  };
  const closeEditSalesMasterSettingModal = useCallback(
    (value) => {
      if (!value) setSelectedSaleSetting(null);
      dispatch(changeSettingValue("editSalesMasterSettingModal", value));
      initialEditSalesMasterSettingModalState();
    },
    [editSalesMasterSettingModal]
  );
  const submitEditSalesMasterSettingForm = (data) => {
    data.setting_type = 1;
    console.log("submitEditSalesMasterSettingForm", data);
    dispatch(updateSalesMasterSetting(data));
  };
  const submitEditPmMasterUpdateSettingForm = (data) => {
    data.setting_type = 2;
    console.log("submitEditPmMasterUpdateSettingForm", data);
    dispatch(updateSalesMasterSetting(data));
  };
  const deleteEditSalesMasterSettingHandler = (id) => {
    // dispatch(deleteEditSalesMasterSetting({ id }));
  };

  const editSalesMasterSettingHandler = (editSalesMasterSetting) => {
    setSelectedSaleSetting(editSalesMasterSetting);
    closeEditSalesMasterSettingModal(true);
    const editValues = {
      master_id: editSalesMasterSetting?.id ?? "",
      sales_type_id: editSalesMasterSetting?.sales_type_id ?? "",
      merchant_id: editSalesMasterSetting?.merchant_id ?? "",
      cluster_id: editSalesMasterSetting?.cluster_id ?? "no",
      store_merchant_id: editSalesMasterSetting?.store_merchant_id ?? "",
    };
    initialEditSalesMasterSettingModalState(editValues);
  };

  /* Edit pm Master Setting END */

  const updateSaleSettingStatusHandler = (id, status) => {
    dispatch(updateSalesMasterSettingStatus({ id, status }));
  };
  const refreshSalesMasterSettingHandler = (id) => {
    dispatch(refreshSalesMasterSetting({ id }));
  };

  const getSalesMasterSettingAction = (salesMasterSetting) => {
    let res = null;
    if (salesMasterSetting?.status == 1) {
      res = (
        <>
          {salesMasterSetting?.setting_type == 1 ? (
            <a
              role="button"
              class="circle_icon edit_tooltip editAccountPm"
              onClick={() => editSalesMasterSettingHandler(salesMasterSetting)}
            >
              <i class="iconSprites edit-icon"></i>
            </a>
          ) : (
            <a
              role="button"
              class="circle_icon refresh_tooltip refresh_setting_pm"
              onClick={() =>
                refreshSalesMasterSettingHandler(salesMasterSetting?.id)
              }
            >
              <i class="iconSprites refresh-icon"></i>
            </a>
          )}

          <a
            role="button"
            class="circle_icon pwr_tooltip on"
            onClick={() =>
              updateSaleSettingStatusHandler(salesMasterSetting?.id, "inactive")
            }
          >
            <i class="iconSprites pwr-icon"></i>
          </a>
        </>
      );
    } else {
      res = (
        <a
          role="button"
          class="circle_icon pwr_tooltip"
          onClick={() =>
            updateSaleSettingStatusHandler(salesMasterSetting?.id, "active")
          }
        >
          <i class="iconSprites pwr-icon"></i>
        </a>
      );
    }
    return res;
  };

  const checkAccountIsClicked = (account) => {
    let res = true;

    if (
      checkArray(accounts) &&
      checkArray(account?.cluster) &&
      checkArray(account?.cluster.filter((p) => checkArray(p.stores)))
    ) {
      let accountIds = [];
      account?.cluster
        .filter((p) => checkArray(p.stores))
        .map((cluster) => {
          if (checkArray(cluster?.stores)) {
            cluster?.stores.map((store) => {
              accountIds.push(store.merchant_id);
            });
          }
        });
      let allSelectedStoreId = [];
      if (checkArray(accounts)) {
        accounts.map((acc) => {
          allSelectedStoreId.push(acc.store_merchant_id);
        });
      }
      return accountIds.every((ai) => allSelectedStoreId.includes(ai));
    } else {
      res = false;
    }
    return res;
  };

  const checkClusterIsClicked = (cluster) => {
    let res = true;
    if (checkArray(accounts) && checkArray(cluster?.stores)) {
      let clusterIds = [];
      cluster?.stores.map((store) => {
        clusterIds.push(store.merchant_id);
      });
      let allSelectedStoreId = [];
      if (checkArray(accounts)) {
        accounts.map((acc) => {
          allSelectedStoreId.push(acc.store_merchant_id);
        });
      }
      return clusterIds.every((ai) => allSelectedStoreId.includes(ai));
    } else {
      res = false;
    }
    return res;
  };

  const otherAccountClickHandler = (other_account) => {
    let newAccounts = [...accounts];
    if (
      newAccounts.findIndex((p) => p.store_merchant_id == other_account?.id) >
      -1
    ) {
      newAccounts = newAccounts.filter(
        (p) => p.store_merchant_id != other_account?.id
      );
    } else {
      newAccounts.push({
        merchant_id: other_account?.parent_merchant_id,
        cluster_id: other_account?.id,
        store_merchant_id: other_account?.id,
      });
    }
    setAccounts(newAccounts);
  };
  const accountClickHandler = (account) => {
    let newAccounts = [...accounts];
    newAccounts = newAccounts.filter((p) => p.merchant_id != account?.id);
    const checkIsClicked = checkAccountIsClicked(account);
    if (checkArray(account?.cluster) && !checkIsClicked) {
      account?.cluster
        .filter((p) => checkArray(p.stores))
        .map((cluster) => {
          if (checkArray(cluster?.stores)) {
            cluster?.stores.map((store) => {
              newAccounts.push({
                merchant_id: account?.id,
                cluster_id: store?.cluster_id,
                store_merchant_id: store?.merchant_id,
              });
            });
          }
        });
    }
    setAccounts(newAccounts);
  };

  const clusterClickHandler = (merchantId, cluster) => {
    let newAccounts = [...accounts];
    newAccounts = newAccounts.filter((p) => p.cluster_id != cluster?.id);
    const checkIsClicked = checkClusterIsClicked(cluster);
    if (checkArray(cluster?.stores) && !checkIsClicked) {
      cluster?.stores.map((store) => {
        newAccounts.push({
          merchant_id: merchantId,
          cluster_id: store?.cluster_id,
          store_merchant_id: store?.merchant_id,
        });
      });
    }
    setAccounts(newAccounts);
  };

  const storeClickHandler = (merchantId, store) => {
    let newAccounts = [...accounts];
    if (
      newAccounts.findIndex((p) => p.store_merchant_id == store?.merchant_id) >
      -1
    ) {
      newAccounts = newAccounts.filter(
        (p) => p.store_merchant_id != store?.merchant_id
      );
    } else {
      newAccounts.push({
        merchant_id: merchantId,
        cluster_id: store?.cluster_id,
        store_merchant_id: store?.merchant_id,
      });
    }
    setAccounts(newAccounts);
  };

  const msetingArr = {
    1: "Master & Lock",
    2: "Push & Forgot",
  };

  return (
    <div className="accordion-item">
      <h2 className="accordion-header" id="paymentMethodMasterSettings">
        <button
          className="accordion-button"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#panelsStayOpen-collapseOne"
          aria-expanded="true"
          aria-controls="panelsStayOpen-collapseOne"
        >
          <div className="col d-flex align-items-center">
            <h4 className="event-alert p-0 mb-0">Sales Type Master Settings</h4>
          </div>{" "}
        </button>
      </h2>
      <div
        id="panelsStayOpen-collapseOne"
        className="accordion-collapse collapse show"
        aria-labelledby="paymentMethodMasterSettings"
      >
        <div className="">
          <div className="row mx-0">
            <div className="container px-0">
              <div className="shadowclass mt-0">
                <div className="table-responsive">
                  <table className="checklist-table remove-space inventory_table">
                    <thead>
                      <tr>
                        <th className="col-2">Sales Type</th>
                        <th className="col-2">Cluster Name</th>
                        <th>Account Name</th>
                        <th>Master Setting</th>
                        <th>Last Push Date</th>
                        <th>Status</th>
                        <th className="action-td">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {checkArray(
                        master_setting_details?.sales_types?.master_settings
                      ) &&
                        master_setting_details?.sales_types?.master_settings.map(
                          (setting) => {
                            return (
                              <tr>
                                <td>{setting?.sales_type?.type_name ?? ""}</td>
                                <td>
                                  {setting?.cluster?.cluster_name
                                    ? setting?.cluster?.cluster_name
                                    : "Orphan - No Cluster"}
                                </td>
                                <td>{setting?.store_merchant?.account_name}</td>
                                <td>{msetingArr?.[setting?.setting_type]}</td>
                                <td>
                                  {changeDateFormat(
                                    setting?.push_date,
                                    "MMMM DD, yyyy"
                                  )}
                                </td>
                                <td>
                                  {" "}
                                  {setting?.status == 1 ? (
                                    <span class="green_tag"> Active </span>
                                  ) : (
                                    <span class="bordered_tag"> Inactive </span>
                                  )}
                                </td>
                                <td>
                                  <div className="d-flex justify-content-center">
                                    {getSalesMasterSettingAction(setting)}{" "}
                                  </div>
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </tbody>
                  </table>
                </div>
                  <div className="my-3">
                    <button
                      className="btn green-btn-revert add-plus"
                      id="addCount"
                      type="button"
                      onClick={() => closeSalesMasterSettingModal(true)}
                    >
                      <i className="i-icon"> </i> Add Account Sales Type
                    </button>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ModelContainer
        title={`${
          salesMasterSettingInputForm?.id != "" ? "EDIT" : "ADD"
        }  ACCOUNT PAYMENT METHOD`}
        open={salesMasterSettingModal}
        closeModal={closeSalesMasterSettingModal}
        submitModal={salesMasterSettingSubmit(submitSalesMasterSettingForm)}
        updateModal={salesMasterSettingSubmit(submitPmMasterUpdateSettingForm)}
        save_btn_name={"Master & Lock"}
        sec_save_btn_name={"Push & Forgot"}
        is_loading={is_salesMasterSetting_loading}
      >
        <form
          class="validate_form"
          id="SalesTypeGeneralSettingSalesForm"
          method="post"
          accept-charset="utf-8"
          novalidate="novalidate"
        >
          <fieldset class="">
            <ul class="form-list label-group new-form">
              <li>
                <label for="SalesTypeTypeName" class="required">
                  Select Sales Type
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    name="data[MasterSettings][sales_type_id]"
                    class="required valid"
                    id="MasterSettingsSalesTypeId"
                    {...salesMasterSettingReg("sales_type_id")}
                    value={salesMasterSettingInputForm?.sales_type_id}
                    onChange={(e) =>
                      changeSalesMasterSettingInputHandler(
                        "sales_type_id",
                        e?.target?.value ?? ""
                      )
                    }
                  >
                    <option value="">Select</option>
                    {checkArray(
                      master_setting_details?.sales_types?.sales_type
                    ) &&
                      master_setting_details?.sales_types?.sales_type.map(
                        (saleType) => {
                          return (
                            <option value={saleType?.id}>
                              {saleType.type_name}
                            </option>
                          );
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={salesMasterSettingErrors}
                    name="sales_type_id"
                  />
                </div>
              </li>
              <li>
                <label for="SelectAccount" class="required">
                  Select Accounts
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    {checkArray(
                      master_setting_details?.sales_types?.all_accounts
                    ) &&
                      master_setting_details?.sales_types?.all_accounts.map(
                        (groups) => {
                          return (
                            <Fragment key={groups?.id}>
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={0}
                                id={`sales_group_id_${groups?.id}`}
                                onClick={() => accountClickHandler(groups)}
                                checked={checkAccountIsClicked(groups)}
                              />
                              <label for={`sales_group_id_${groups?.id}`}>
                                Group - {groups?.account_name ?? ""}
                              </label>

                              <a
                                class="link"
                                role="button"
                                data-bs-toggle="collapse"
                                data-bs-target={`.sales-account-multi-collapse-${groups?.id}`}
                                aria-expanded="false"
                                aria-controls={`sales-account-collapse-${groups?.id}`}
                              >
                                {" "}
                                <i className="btn dropdown" />{" "}
                              </a>
                              <div
                                id={`sales-account-collapse-${groups?.id}`}
                                className={`group-collapse inner-checkbox collapse sales-account-multi-collapse-${groups?.id}`}
                              >
                                {checkArray(groups?.cluster) &&
                                  groups?.cluster
                                    .filter((p) => checkArray(p.stores))
                                    .map((cluster) => {
                                      return (
                                        <div class="groupSec">
                                          <div className="checkbox avaiCheck flex-wrap">
                                            <input
                                              type="checkbox"
                                              className="avail_checkbox"
                                              value={true}
                                              id={`sales_cluster_id_${cluster?.id}`}
                                              onClick={() =>
                                                clusterClickHandler(
                                                  groups?.id,
                                                  cluster
                                                )
                                              }
                                              checked={checkClusterIsClicked(
                                                cluster
                                              )}
                                            />
                                            <label
                                              for={`sales_cluster_id_${cluster?.id}`}
                                            >
                                              Cluster -{" "}
                                              {cluster?.cluster_name ?? ""}
                                            </label>
                                            {checkArray(cluster?.stores) && (
                                              <>
                                                <a
                                                  class="link"
                                                  role="button"
                                                  data-bs-toggle="collapse"
                                                  data-bs-target={`.sales-cluster-multi-collapse-${cluster?.id}`}
                                                  aria-expanded="false"
                                                  aria-controls={`sales-cluster-collapse-${cluster?.id}`}
                                                >
                                                  {" "}
                                                  <i className="btn dropdown" />{" "}
                                                </a>
                                                <div
                                                  class={`pt-3 collapse inner-checkbox sales-cluster-multi-collapse-${cluster?.id}`}
                                                  id={`sales-cluster-collapse-${cluster?.id}`}
                                                >
                                                  {checkArray(
                                                    cluster?.stores
                                                  ) &&
                                                    cluster?.stores.map(
                                                      (store) => {
                                                        return (
                                                          <div className="checkbox avaiCheck">
                                                            <input
                                                              type="checkbox"
                                                              className="avail_checkbox"
                                                              value={true}
                                                              id={`sales_store_id_${store?.id}`}
                                                              onClick={() =>
                                                                storeClickHandler(
                                                                  groups?.id,
                                                                  store
                                                                )
                                                              }
                                                              checked={
                                                                accounts.findIndex(
                                                                  (p) =>
                                                                    p.store_merchant_id ==
                                                                    store.merchant_id
                                                                ) > -1
                                                              }
                                                            />
                                                            <label
                                                              for={`sales_store_id_${store?.id}`}
                                                            >
                                                              Store -{" "}
                                                              {store?.merchant
                                                                ?.account_name ??
                                                                ""}
                                                            </label>
                                                          </div>
                                                        );
                                                      }
                                                    )}
                                                </div>
                                              </>
                                            )}
                                          </div>
                                        </div>
                                      );
                                    })}
                              </div>
                            </Fragment>
                          );
                        }
                      )}
                  </div>
                </div>
              </li>
              <li>
                <label for="OrphanAccount" class="required">
                  <strong>Orphan</strong> - No Cluster
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    {checkArray(
                      master_setting_details?.sales_types?.other_accounts
                    ) &&
                      master_setting_details?.sales_types?.other_accounts.map(
                        (other_account) => {
                          return (
                            <Fragment key={other_account?.id}>
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={0}
                                id={`sales_other_account_id_${other_account?.id}`}
                                onClick={() =>
                                  otherAccountClickHandler(other_account)
                                }
                                checked={
                                  accounts.findIndex(
                                    (p) =>
                                      p.store_merchant_id == other_account.id
                                  ) > -1
                                }
                              />
                              <label
                                for={`sales_other_account_id_${other_account?.id}`}
                              >
                                Store - {other_account?.account_name ?? ""}
                              </label>
                            </Fragment>
                          );
                        }
                      )}
                  </div>
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
      <ModelContainer
        title={`EDIT ACCOUNT PAYMENT METHOD`}
        open={editSalesMasterSettingModal}
        closeModal={closeEditSalesMasterSettingModal}
        submitModal={editSalesMasterSettingSubmit(
          submitEditSalesMasterSettingForm
        )}
        updateModal={editSalesMasterSettingSubmit(
          submitEditPmMasterUpdateSettingForm
        )}
        save_btn_name={"Master & Lock"}
        sec_save_btn_name={"Push & Forgot"}
        is_loading={is_editSalesMasterSetting_loading}
      >
        <form
          class="validate_form"
          id="SalesTypeGeneralSettingSalesForm"
          method="post"
          accept-charset="utf-8"
          novalidate="novalidate"
        >
          {console.log(
            "editSalesMasterSettingErrors:",
            editSalesMasterSettingErrors
          )}
          <fieldset class="">
            <ul class="form-list label-group new-form">
              <li>
                <label for="SalesTypeTypeName" class="required">
                  Type Name
                </label>{" "}
                <div class="input-wrap select-div">
                  <select
                    name="data[MasterSettings][sales_type_id]"
                    class="required valid"
                    id="MasterSettingsSalesTypeId"
                    {...editSalesMasterSettingReg("sales_type_id")}
                    value={editSalesMasterSettingInputForm?.sales_type_id}
                    disabled
                  >
                    <option value="">Select</option>
                    {checkArray(
                      master_setting_details?.sales_types?.sales_type
                    ) &&
                      master_setting_details?.sales_types?.sales_type.map(
                        (saleType) => {
                          return (
                            <option value={saleType?.id}>
                              {saleType.type_name}
                            </option>
                          );
                        }
                      )}
                  </select>{" "}
                  <ErrorContainer
                    errors={editSalesMasterSettingErrors}
                    name="sales_type_id"
                  />
                </div>
              </li>
              <li>
                <label for="SelectAccount" class="required">
                  Select Accounts
                </label>

                <div className="checkBoxes">
                  <div className="checkbox avaiCheck flex-wrap">
                    <input
                      type="checkbox"
                      className="avail_checkbox"
                      value={0}
                      id={`edit_sales_group_id_${selectedSaleSetting?.id}`}
                      checked={true}
                      disabled={true}
                    />
                    <label
                      for={`edit_sales_group_id_${selectedSaleSetting?.id}`}
                    >
                      Group -{" "}
                      {selectedSaleSetting?.merchant?.account_name ?? ""}
                    </label>

                    <a
                      class="link"
                      role="button"
                      data-bs-toggle="collapse"
                      data-bs-target={`.sales-account-multi-collapse-${
                        selectedSaleSetting?.id ?? ""
                      }`}
                      aria-expanded="true"
                      aria-controls={`sales-account-collapse-${
                        selectedSaleSetting?.id ?? ""
                      }`}
                    >
                      {" "}
                      <i className="btn dropdown" />{" "}
                    </a>
                    <div
                      id={`sales-account-collapse-${
                        selectedSaleSetting?.id ?? ""
                      }`}
                      className={`group-collapse inner-checkbox sales-account-multi-collapse-${
                        selectedSaleSetting?.id ?? ""
                      }`}
                    >
                      <div class="groupSec">
                        <div className="checkbox avaiCheck flex-wrap">
                          <input
                            type="checkbox"
                            className="avail_checkbox"
                            value={true}
                            id={`sales_cluster_id_${
                              selectedSaleSetting?.cluster?.id ?? 0
                            }`}
                            checked={true}
                            disabled={true}
                          />
                          <label
                            for={`sales_cluster_id_${
                              selectedSaleSetting?.cluster?.id ?? 0
                            }`}
                          >
                            {selectedSaleSetting?.cluster?.cluster_name
                              ? `Cluster - ${selectedSaleSetting?.cluster?.cluster_name}`
                              : `Orphan - No Cluster`}
                          </label>
                          <a
                            class="link"
                            role="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`.sales-cluster-multi-collapse-${selectedSaleSetting?.cluster?.id}`}
                            aria-expanded="true"
                            aria-controls={`sales-cluster-collapse-${selectedSaleSetting?.cluster?.id}`}
                          >
                            {" "}
                            <i className="btn dropdown" />{" "}
                          </a>
                          <div
                            class={`pt-3 inner-checkbox sales-cluster-multi-collapse-${selectedSaleSetting?.cluster?.id}`}
                            id={`sales-cluster-collapse-${selectedSaleSetting?.cluster?.id}`}
                          >
                            <div className="checkbox avaiCheck">
                              <input
                                type="checkbox"
                                className="avail_checkbox"
                                value={true}
                                id={`store_id_${selectedSaleSetting?.store_merchant?.id}`}
                                checked={true}
                                disabled={true}
                              />
                              <label
                                for={`store_id_${selectedSaleSetting?.store_merchant?.id}`}
                              >
                                Store -{" "}
                                {selectedSaleSetting?.store_merchant
                                  ?.account_name ?? ""}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </fieldset>
        </form>
      </ModelContainer>
    </div>
  );
};
export default Sales;
